module.exports = __webpack_public_path__ + "img/button_live.2d13425a.png";